import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const TIMELINES = ["Just researching", "0–3 months", "3–6 months", "6–12 months", "PCS orders in hand"];

export default function AskFrankForm({ compact = false, sourceCity = "" }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", timeline: "", message: "" });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error("Please add your name, email and question.");
      return;
    }
    setSending(true);
    try {
      await api.post("/contact", { ...form, source_city: sourceCity });
      toast.success("Got it — Frank will get back to you personally.");
      setForm({ name: "", email: "", phone: "", timeline: "", message: "" });
    } catch {
      toast.error("Something went wrong — please try again.");
    } finally {
      setSending(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-brand-border-sand bg-white px-4 py-3 text-sm text-brand-navy-dark placeholder:text-brand-slate/50 focus:outline-none focus:ring-2 focus:ring-brand-navy/30 transition-shadow";

  return (
    <form data-testid="lead-contact-form" onSubmit={submit} className={compact ? "space-y-3" : "space-y-4"}>
      <div className="grid sm:grid-cols-2 gap-3">
        <input data-testid="lead-name-input" className={inputCls} placeholder="Full name *" value={form.name} onChange={set("name")} />
        <input data-testid="lead-email-input" className={inputCls} type="email" placeholder="Email *" value={form.email} onChange={set("email")} />
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <input data-testid="lead-phone-input" className={inputCls} type="tel" placeholder="Phone (optional)" value={form.phone} onChange={set("phone")} />
        <select data-testid="lead-timeline-select" className={inputCls} value={form.timeline} onChange={set("timeline")}>
          <option value="">Moving timeline…</option>
          {TIMELINES.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </div>
      <textarea data-testid="lead-message-input" className={`${inputCls} min-h-[110px] resize-y`} placeholder="Your question about Sierra Vista, relocation, or a home… *" value={form.message} onChange={set("message")} />
      <button data-testid="lead-submit-button" type="submit" disabled={sending}
        className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-brand-red text-white font-bold text-sm px-6 py-3.5 hover:bg-brand-red-dark transition-colors disabled:opacity-60">
        {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
        {sending ? "Sending…" : "Send My Question to Frank"}
      </button>
    </form>
  );
}
